import { brand } from './config/brand';

const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

export const API_BASE_URL = isProduction
  ? `https://${window.location.hostname}/api`
  : 'http://localhost:8093/api';

export const TURNSTILE_SITE_KEY = brand.turnstileSiteKey;

export const getArtworkUrl = (gameId: string, updatedAt?: string, token?: string | null) => {
  const t = updatedAt ? new Date(updatedAt).getTime() : Date.now();
  const authParam = token ? `&token=${token}` : '';
  return `${API_BASE_URL}/games/${gameId}/artwork?t=${t}${authParam}`;
};

